<template>
  <div>
    <div class="mb-3">
      <h5>
        <b-button class="p-0" variant="transparent"><span class="mdi mdi-chevron-left-box font-size-24 align-middle" @click="$emit('change-mode','list')"/></b-button>
        {{ mode === 'create' ? '요금 신규 등록' : `${$_app.code.busiId[form.comCode]} ${form.priceType ? `(${form.priceType})` : "" } 요금 수정` }}
      </h5>
      <hr/>
    </div>
    <vue-custom-scrollbar>
      <div style="max-height: 63vh">
        <div class="card-body">
          <div class="card">
            <div class="card-body">
              <card-title title="사업자 충전 요금 정보 관리" text-color="title"/>

              <div class="row">
                <div class="col-xl-6">
                  <div class="card-body">
                    <div class="row">

                      <div class="col-lg-6">
                        <div class="form-group row">
                          <div class="col-lg-4">
                            <label for="come-code-input" class="col-form-label">사업자명</label>
                          </div>
                          <div class="col">
                            <b-form-select
                                class="form-select"
                                type="text"
                                id="come-code-input"
                                v-model="form.comCode"
                                :options="comeCodeOptions"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-group row">
                          <div class="col-lg-4">
                            <label for="price-change-date-input" class="col-form-label">요금 변경일</label>
                          </div>
                          <div class="col-lg-8">
                            <date-picker
                                type="date" id="price-change-date-input" lang="ko"
                                v-model="form.priceChangeDate"
                                value-type="YYYY-MM-DD HH:mm:ss">
                            </date-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-6">
                  <div class="card-body">
                    <div class="form-group row">
                      <div class="col-lg-2">
                        <label for="price-desc-input" class="col-form-label">안내문구</label>
                      </div>
                      <div class="col-lg">
                        <b-form-textarea
                            id="price-desc-input"
                            v-model="form.priceDesc"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <card-title title="완속 요금 정보" text-color="title"/>
              <div class="row">
                <div class="col-xxl-6">
                  <div class="card-body">
                    <div class="row">

                      <div class="col-lg-5">
                        <div class="form-group row">
                          <div class="col-lg-5">
                            <label for="price-type-input" class="col-form-label">유형 <br class="d-none d-xxl-inline">(3
                              or
                              7kW)</label>
                          </div>
                          <div class="col">
                            <b-form-select
                                type="text" id="price-type-input"
                                v-model="form.priceType"
                                class="form-select"
                                :options="priceTypeOptions"/>
                          </div>
                        </div>

                      </div>

                      <div class="col-lg-3">
                        <div class="form-group row">
                          <div class="col-lg-5">
                            <label for="capacity-power-input" class="col-form-label">설비용량</label>
                          </div>
                          <div class="col-lg-7">
                            <b-form-select
                                type="number" id="capacity-power-input"
                                v-model="form.capacityPower"
                                class="form-select"
                                :options="capacityPowerOptions"/>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="form-group row">
                          <div class="col-lg-4">
                            <label for="basic-price-input" class="col-form-label">기본요금</label>
                          </div>
                          <div class="col">
                            <b-form-input type="number" step="0.1" id="basic-price-input" v-model="form.basicPrice"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-body form-group">
                    <div class="row justify-content-end">
                      <div class="col-10">
                        <div
                            class="d-flex justify-content-between col-form-label rounded mb-2 bg-opacity-25 bg-primary">
                          <span class="col-3 text-center">봄/가을</span>
                          <span class="col-3 text-center">여름</span>
                          <span class="col-3 text-center">겨울</span>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-2 col-form-label">
                        <span>경부하</span>
                      </div>
                      <div class="col-10 d-flex justify-content-between">
                        <div class="col-3">
                          <b-form-input type="number" step="0.1" id="sf-ac-light-input" v-model="form.sfAcPrice.light"/>
                        </div>
                        <div class="col-3">
                          <b-form-input type="number" step="0.1" id="sm-ac-light-input" v-model="form.smAcPrice.light"/>
                        </div>
                        <div class="col-3">
                          <b-form-input type="number" step="0.1" id="wt-ac-light-input" v-model="form.wtAcPrice.light"/>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-2">
                      <div class="col-2 col-form-label">
                        <span>중부하</span>
                      </div>
                      <div class="col-10 d-flex justify-content-between">
                        <div class="col-3">
                          <b-form-input type="number" step="0.1" id="sf-ac-heavy-input" v-model="form.sfAcPrice.heavy"/>
                        </div>
                        <div class="col-3">
                          <b-form-input type="number" step="0.1" id="sm-ac-heavy-input" v-model="form.smAcPrice.heavy"/>
                        </div>
                        <div class="col-3">
                          <b-form-input type="number" step="0.1" id="wt-ac-heavy-input" v-model="form.wtAcPrice.heavy"/>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-2 col-form-label">
                        <span>최대부하</span>
                      </div>
                      <div class="col-10 d-flex justify-content-between">
                        <div class="col-3">
                          <b-form-input type="number" step="0.1" id="sf-ac-max-input" v-model="form.sfAcPrice.max"/>
                        </div>
                        <div class="col-3">
                          <b-form-input type="number" step="0.1" id="sm-ac-max-input" v-model="form.smAcPrice.max"/>
                        </div>
                        <div class="col-3">
                          <b-form-input type="number" step="0.1" id="wt-ac-max-input" v-model="form.wtAcPrice.max"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xxl-6">

                  <div class="card-body">
                    <div class="row">
                      <div class="col-2 col-xxl-12 col-form-label">
                        <span>기타 완속 요금</span>
                      </div>
                      <div class="col-10 col-xxl-12">
                        <div
                            class="d-flex justify-content-between col-form-label rounded mb-2 bg-opacity-25 bg-primary">
                          <span class="col-5 text-center">3.5kW</span>
                          <span class="col-5 text-center">11kW</span>
                        </div>
                      </div>
                    </div>

                    <div class="row justify-content-end">
                      <div class="col-10 col-xxl-12">
                        <div class="d-flex justify-content-between mb-2">
                          <div class="col-5">
                            <b-form-input type="number" step="0.1" id="etc-ac-three-point-five-input"
                                          v-model="form.etcAcPrice['3.5']"/>
                          </div>
                          <div class="col-5">
                            <b-form-input type="number" step="0.1" id="etc-ac-11-input" v-model="form.etcAcPrice['11']"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-xxl-6">

                  <card-title title="급속 요금 정보" text-color="title"/>
                  <div class="card-body form-group">
                    <div class="row justify-content-end">
                      <div class="col-xxl-10">
                        <div
                            class="d-flex justify-content-between col-form-label rounded mb-2 bg-opacity-25 bg-primary">
                          <span class="col-2 text-center">25~30 kW</span>
                          <span class="col-2 text-center">50 kW</span>
                          <span class="col-2 text-center">100 kW</span>
                          <span class="col-2 text-center">150 kW</span>
                          <span class="col-2 text-center">350 kW 이상</span>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-end">
                      <div class="col-xxl-10 d-flex justify-content-between mb-2">
                        <div class="col-2">
                          <b-form-input type="number" step="0.1" id="dc-price-25-input" v-model="form.dcPrice['25~30']"/>
                        </div>
                        <div class="col-2">
                          <b-form-input type="number" step="0.1" id="dc-price-50-input" v-model="form.dcPrice['50']"/>
                        </div>
                        <div class="col-2">
                          <b-form-input type="number" step="0.1" id="dc-price-100-input" v-model="form.dcPrice['100']"/>
                        </div>
                        <div class="col-2">
                          <b-form-input type="number" step="0.1" id="dc-price-150-input" v-model="form.dcPrice['150']"/>
                        </div>
                        <div class="col-2">
                          <b-form-input type="number" step="0.1" id="high-power-price-input" v-model="form.highPowerPrice"/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <card-title title="비회원" text-color="title"/>
                  <div class="card-body form-group">
                    <div class="row justify-content-end">
                      <div class="col-xxl-10">
                        <div class="d-flex col-form-label rounded mb-2 bg-opacity-25 bg-primary">
                          <span class="col-4 text-center">완속/급속 동일</span>
                        </div>
                      </div>
                    </div>
                    <div class="row justify-content-end">
                      <div class="col-xxl-10">
                        <div class="d-flex col-lg-4">
                          <b-form-input type="number" step="0.1" id="com-code-input" v-model="form.nonMemberPrice"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xxl-6">
                  <card-title title="로밍 요금 정보" text-color="title"/>
                  <div class="card-body form-group">
                    <div class="row justify-content-end">
                      <div class="col-10 col-xxl-9">
                        <div
                            class="d-flex justify-content-between col-form-label rounded mb-2 bg-opacity-25 bg-primary">
                          <div class="col-6 text-center">로밍 사업자명</div>
                          <span class="col-5 text-center">로밍요금</span>
                        </div>
                      </div>
                      <div class="col"></div>
                    </div>

                    <vue-custom-scrollbar class="scroll-area" :settings="scrollSettings">
                      <div style="max-height: 200px">
                        <div class="row" v-for="(roaming, i) in roamingCompany" :key="`roamingListPrice${i}`">
                          <div class="col-10 col-xxl-9">
                            <div class="d-flex justify-content-between mb-2 ">
                              <div class="col-6">
                                <b-form-input type="text" id="roaming-company-input" v-model="roamingCompany[i]"/>
                              </div>
                              <div class="col-5">
                                <b-form-input type="number" step="0.1" id="roaming-price-input" v-model="roamingPrice[i]"/>
                              </div>
                            </div>
                          </div>


                          <div class="col">
                            <div class="mt-1">
                              <b-button size="xs" variant="outline-primary" class="btn-sm me-2 row-6"
                                        v-if="roamingCompany.length-1===i"
                                        @click="roamingCompany.push(null)">추가
                              </b-button>
                              <b-button size="xs" variant="outline-danger" class="btn-sm row-6"
                                        v-if="i !== 0"
                                        @click="delRoamingInput(i)">삭제
                              </b-button>
                            </div>
                          </div>
                        </div>

                      </div>
                    </vue-custom-scrollbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </vue-custom-scrollbar>
    <br/>

    <div class="d-flex justify-content-end">
      <b-button variant="primary" class="me-3" @click="save()">저장</b-button>
      <b-button @click="$emit('change-mode','list')">목록</b-button>
    </div>

  </div>
</template>

<script>
import CardTitle from "@/views/components/cardTitle.vue";
import "vue-custom-scrollbar/dist/vueScrollbar.css"
import vueCustomScrollbar from 'vue-custom-scrollbar'
import EventBus from "@/views/layouts/event-bus";
import ko from "vue2-datepicker/locale/es/ko";

export default {
  name: "ManageFeeInputForm",
  computed: {
    ko() {
      return ko
    }
  },
  components: { CardTitle, vueCustomScrollbar },
  props: {
    mode: String,
    selectedRow: Object,
  },
  data() {
    const _api = this.$_app.service.comPriceSeason;

    return {
      jqlApi: _api,
      // showTimePanel: false,
      scrollSettings: {
        suppressScrollY: false,
        suppressScrollX: true,
        wheelPropagation: false
      },
      form: {
        comCode: null,
        priceChangeDate: null,
        priceDesc: null,
        priceType: null,
        capacityPower: null,
        basicPrice: null,
        sfAcPrice: {
          light: null,
          heavy: null,
          max: null
        },
        smAcPrice: {
          light: null,
          heavy: null,
          max: null
        },
        wtAcPrice: {
          light: null,
          heavy: null,
          max: null
        },
        etcAcPrice: {
          '3.5': null,
          '11': null
        },
        dcPrice: {
          '25~30': null,
          '50': null,
          '100': null,
          '150': null
        },
        highPowerPrice: null,
        nonMemberPrice: null,
        roamingListPrice: null,
      },
      roamingCompany: [null],
      roamingPrice: [],
      roamingObjs: [{}],

      comeCodeOptions: [],
      priceTypeOptions: [],
      capacityPowerOptions: [
        { value: 3, text: '3kW' },
        { value: 7, text: '7kW' }
      ],
    }
  },
  methods: {
    getComCodeOptions() {
      const vm = this;

      vm.comeCodeOptions = Object.entries(this.$_app.code.busiId).map(([key, value]) => ({ value: key, text: value }));
    },
    getPriceTypeOptions() {
      const vm = this;

      vm.priceTypeOptions = Object.entries(this.$_app.code.priceType).map(([key, value]) => ({ value: key, text: value }));
    },
    handleOpenChange() {
      const vm = this;
      vm.showTimePanel = false;
    },
    toggleTimePanel() {
      const vm = this;
      vm.showTimePanel = !vm.showTimePanel;
    },
    delRoamingInput(i) {
      const vm = this;
      vm.roamingCompany.splice(i, 1);
      vm.roamingPrice.splice(i, 1)
    },
    setRoamingListPrice() {
      const vm = this;

      const coLen = vm.roamingCompany.length;
      const lastCompany = this.roamingCompany[coLen - 1];

      if (lastCompany === null || lastCompany === "") {
        if (coLen === 1) vm.form.roamingListPrice = null;
        else vm.roamingCompany.pop();
      } else if (coLen === vm.roamingPrice.length) {
        vm.roamingObjs = vm.roamingCompany.map((ele, i) => ({ [ele]: vm.roamingPrice[i] }));
        vm.form.roamingListPrice = { "list": vm.roamingObjs };
      } else {
        this.$swal('로밍정보를 정확히 입력해주세요', '', 'warning');
        throw new Error("roaming input empty");
      }
    },
    save() {
      const vm = this;
      const entity = vm.form;

      vm.setRoamingListPrice();

      if (this.$_utils.isEmpty(vm.form.comCode)) {
        this.$swal('사업자명을 선택해주세요', '', 'warning');
        throw new Error("comCode input empty");
      }

      if (this.mode === 'create') {
        vm.jqlApi.add(entity)
          .then(res => {
            this.$swal('등록 완료', '등록이 완료되었습니다.', 'success');
            this.$emit('change-mode', 'list');
          }).catch(err => {
            console.log(err);
            this.$swal('등록 실패', '등록에 실패하였습니다.', 'error')
          });
      } else if (this.mode === 'update') {
        vm.jqlApi.updateByIdList(vm.selectedRow.id, entity)
          .then(res => {
            this.$swal('수정 완료', '수정이 완료되었습니다.', 'success');
            this.$emit('change-mode', 'list');
          }).catch(err => {
            console.log(err);
            this.$swal('수정 실패', '수정에 실패하였습니다.', 'error');
          });
      }
    },
  },
  created () {
    const vm = this;

    vm.getComCodeOptions();
    vm.getPriceTypeOptions();
    if (vm.mode === 'create') vm.form.priceDesc= "충전요금은 사업자에 따라 설치 장소 특정 상황에 따라 달라질 수 있으니 참고용으로 활용하시길 바랍니다.";

    if (vm.mode === 'update') {
      vm.form = Object.assign({}, this.selectedRow);

      if(!this.$_utils.isEmpty(vm.form.roamingListPrice)) {
        vm.roamingCompany = vm.form.roamingListPrice.list.map(ele => Object.keys(ele)[0]);
        vm.roamingPrice = vm.form.roamingListPrice.list.map(ele => Object.values(ele)[0]);
      }
    }
  },
}
</script>

<style scoped lang="scss">

</style>